import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#06BA53",
				secondary: "#61B565",
				accent: "#707070",
			},
		},
	},
});
